import React from "react";
import { ImagesSentSuccessContextType } from "./types";

export const ImagesSentSuccessContext = React.createContext<
  ImagesSentSuccessContextType | undefined
>(undefined);
